import { Chain, ChainID } from '@ankr.com/chains-list';

import { getSubchainIds } from './getSubchainIds';

interface GetChainBySubchainIDParams {
  chainID: ChainID;
  chains: Chain[];
}

export const getChainBySubchainID = ({
  chainID,
  chains,
}: GetChainBySubchainIDParams) => {
  const mainChain = chains.find(chain => chain.id === chainID);

  if (mainChain) {
    return mainChain;
  }

  return chains.find(chain => {
    if (chain.id === chainID) {
      return true;
    }

    if (chainID === ChainID.AVALANCHE_EVM && chain.id === ChainID.AVALANCHE) {
      return true;
    }

    return getSubchainIds(chain).includes(chainID);
  });
};
